import { connect } from 'react-redux';
import { getCurrentOrganizationFactory } from '@/store/authentication/authentication.selectors';

export default (mapState?: (mapped: any, state: any, props: any) => any) => {
  const getCurrentOrganization = getCurrentOrganizationFactory();

  const mapStateToProps = (state: any, props: any) => {
    const mapped = {
      organizationTenantId: state.authentication.organizationId,
      organizationId: state.authentication.organization,
      organization: getCurrentOrganization(state),
    };
    return mapState ? mapState(mapped, state, props) : mapped;
  };
  return connect(mapStateToProps);
};
